export default {
    current_choice: 'Nykyinen valinta',
    book_now: 'Varaa nyt',
    minimum_age: 'Vain yli {age}-vuotiaille',
    excess_liability: 'Omavastuu',
    security_deposit: 'Vakuusmaksu',
    fuel_policy: 'Polttoainekäytäntö',
    like_for_like: 'Sama määrä kuin samaan',
    full_to_full: 'Täysi tankki täyteen',
    miles_per_rental: '{mileage} mailia ilmaiseksi per vuokraus',
    km_per_rental: '{mileage} km ilmaiseksi per vuokraus',
    unlimited_mileage: 'Rajoittamaton ajomatka',
    unlimited_mileage_km: 'Rajoittamaton km',
    non_amendable: 'Ei muutettavissa',
    non_refundable: 'Ei palautettavissa',
    free_cancellation_until: 'Ilmainen peruutus asti',
    basic_free_cancellation: 'Ilmainen peruutus viimeistään 48 tuntia ennen alkamisaikaa',
    cancellation_in_line_with: 'Peruutus linjassa',
    tcs: 'Ehdot',
    free_extras_on_collection: 'Kaksi ilmaista lisävarustetta noudettaessa',
    glass_and_tyres_covered: 'Lasit ja renkaat katettu',
    number_of_passengers: 'Matkustajien lukumäärä',
    number_of_bags: 'Laukkujen lukumäärä',
    fuel_type: 'Polttoainetyyppi',
    co2: 'CO2',
    aircon: 'Ilmastointi',
    transmission: 'Vaihteisto',
    book_type: 'Varaa {type}',
    debit_card_deposit: 'Pankkikortti hyväksytty vakuusmaksuihin',
    fast_track_included: 'Pikakaista sisältyy',
    view_all: 'Näytä kaikki',
};
